export const validationDialogZIndex = 10002;
export const scrollbarZIndex = validationDialogZIndex + 1;
